// removed by extract-text-webpack-plugin
module.exports = {"button":"magazines_127GD","button__size-small":"magazines_38N18","button__size-large":"magazines_GvFVA","button__color-light":"magazines_2liMO","button__color-primary":"magazines_3YpQQ","button__color-success":"magazines_Frakr","button__color-dark":"magazines_12WC7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Button/styles.scss
// module id = 1003
// module chunks = 1